export const carouselItemSelector = (state: RootState) => state.website.carouselItems;
export const carouselItemsLoadingSelector = (state: RootState) => state.website.loadingCarousel;


export const createCarouselErrorSelector = (state: RootState) => state.website.errorCreatingCarousel;
export const deleteCarouselErrorSelector = (state: RootState) => state.website.errorDeletingCarousel;
export const editCarouselErrorSelector = (state: RootState) => state.website.errorEditingCarousel;